<template>
  <v-row>
    <v-col cols="12">
      <h2>{{ $t('log_wallet.head') }}</h2>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('log_wallet.head_list') }} </v-card-title>
        <v-card-actions>
          <v-spacer />
          <span class="px-3 mt-5">{{ $t('search') }}:</span>
          <div style="width: 150px" class="mt-5">
            <v-text-field v-debounce:500ms="searchKeyword" :date="searchData" outlined dense hide-details />
          </div>
        </v-card-actions>
        <v-card-actions class="pt-0">
          <v-data-table mobile-breakpoint="0" style="width: 100%" :headers="headers" :items="logwallets"
            :no-data-text="$t('not_found')" :no-results-text="$t('not_found')" :options.sync="pagination"
            :server-items-length="pagination.totalItems" :items-per-page="pagination.rowsPerPage"
            :page.sync="pagination.page" :loading="loading" :search="search" :footer-props="{
              'items-per-page-options': [10, 25, 30, 40, 50],
            }">
            <template v-slot:[`item.principalAmount`]="{ item }">
              <span>{{ formatAmount(item.principalAmount) }}</span>
            </template>
            <template v-slot:[`item.bonusAmount`]="{ item }">
              <span>{{ formatAmount(item.bonusAmount) }}</span>
            </template>
            <template v-slot:[`item.displayDetail`]="{ item }">
              <span
                :class="{ 'error--text': !!item.errorMessage }"
              >
                {{ item.displayDetail }}
              </span>
            </template>
            <template v-slot:[`item.updatedAt`]="{ item }">
              <span>{{ formatDate(item.updatedAt) }}</span>
            </template>
          </v-data-table>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import DatePickerInput from '@/components/input/DatePickerInput.vue'
import SelectInput from '@/components/input/SelectInput.vue'
import AccountDetail from '@/components/logs/AccountDetail.vue'
import store from '@/store'
export default {
  components: {
    DatePickerInput,
    SelectInput,
    AccountDetail,
  },

  data() {
    return {
      searchData: null,
      headers: [
        {
          text: this.$t('log_wallet.header'),
          value: 'phone',
          width: '80px',
          sortable: false,
        },
        {
          text: this.$t('log_wallet.header1'),
          value: 'transferType',
          width: '100px',
          sortable: false,
        },

        {
          text: this.$t('log_wallet.header2'),
          value: 'fromProvider',
          sortable: false,
        },
        {
          text: this.$t('log_wallet.header3'),
          value: 'toProvider',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('log_wallet.header4'),
          value: 'principalAmount',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('log_wallet.header5'),
          value: 'bonusAmount',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('log_wallet.header6'),
          value: 'status',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('log_wallet.header7'),
          value: 'displayDetail',
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('log_wallet.header8'),
          value: 'updatedAt',
          align: 'center',
          sortable: false,
        },
      ],
      logwallets: [],
      search: '',
      loading: false,
      dummy: true,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
      },
    }
  },
  async created() {
    this.addLogPage()
  },
  watch: {
    pagination: {
      async handler(newValue, oldValue) {
        let cont = false
        if (oldValue.page !== newValue.page) cont = true
        if (oldValue.itemsPerPage !== newValue.itemsPerPage) cont = true
        if (oldValue.sortBy !== newValue.sortBy) cont = true
        if (oldValue.sortDesc !== newValue.sortDesc) cont = true
        if (cont && !this.dummy) {
          this.loading = true
          let result = []
          result = this.searchData ?
            await this.getLogWallet(`page=${newValue.page}&rows=${newValue.itemsPerPage}&search=${this.searchData}`) :
            await this.getLogWallet(`page=${newValue.page}&rows=${newValue.itemsPerPage}`)
          this.logwallets = result.data.map(item => ({
            ...item,
            displayDetail: item.detail || '',
          }));
          this.pagination.totalItems = result.count
          this.loading = false
        }
        if (cont && this.dummy) {
          this.loading = true
          let result = []
          result = this.searchData ?
            await this.getLogWallet(`page=${newValue.page}&rows=${newValue.itemsPerPage}&search=${this.searchData}`) :
            await this.getLogWallet(`page=${newValue.page}&rows=${newValue.itemsPerPage}`)
          this.logwallets = result.data.map(item => ({
            ...item,
            displayDetail: item.detail || '',
          }));
          this.pagination.totalItems = result.count
          this.loading = false
        }
      },
      deep: true,
    },
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'Logs (กระเป๋า)',
            url: window.location.href,
            detail: 'รายการ Logs (กระเป๋า)',
            admin: userSystem.name ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
      }
    },
    async getLogWallet(params) {
      try {
        return this.$store.dispatch('getLogWallet', params)
      } catch (e) {
        if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
          this.$swal.fire({
            icon: 'error',
            title: e.message,
          })
        }
      }
    },
    async searchKeyword(value) {
      this.dummy = true;
      this.searchData = value
      this.loading = true
      let result = {}
      if (value) {
        result = await this.getLogWallet(`page=1&rows=${this.pagination.rowsPerPage}&search=${value}`)
      } else {
        result = await this.getLogWallet(`page=1&rows=${this.pagination.rowsPerPage}`)
      }
      this.pagination.totalItems = result.count
      this.logs = result.data
      this.logwallets = result.data.map(item => ({
        ...item,
        displayDetail: item.detail || '',
      }));
      this.loading = false
      this.pagination.page = 1
    },
    formatDate(date) {
      return moment(date).format('YY-MM-DD HH:mm')
    },
    formatDateYYYY(date) {
      const dateConv = date?.length > 8 ? date.substring(2) : date
      return moment(`20${dateConv}`).format('YYYY-MM-DD')
    },
    formatAmount(value) {
      if (value === null || value === undefined || value === '') {
        return '0.00'
      }

      return Number(value).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },
  },
}
</script>
